import { useQuery } from '@tanstack/react-query';
import QueryKey from '../utils/queryKeys';
import { createClient, fetchExchange } from '@urql/core';
import { getBaseApiURL } from '../helper';
import { useAccountChainIdOrDefault } from './useAccountChainIdOrDefault';

export const useUrqlClient = () => {
  const chainId = useAccountChainIdOrDefault();
  return useQuery({
    enabled: !!chainId,
    queryKey: [QueryKey.URQL_CLIENT, { chainId }],
    queryFn: () => ({
      client: createClient({
        url: getBaseApiURL(chainId),
        exchanges: [fetchExchange],
      }),
      chainId,
    }),
    staleTime: Infinity,
  });
};
